<template>
  <div>
    <div class="row">
      <div class="col-12 float-right m-2">
        <el-tooltip
          placement="top"
          :content="$t('instruction')">
            <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            @click="instructionOpen">
            <!-- {{ $t("instruction") }} -->
            <app-icon name="book-open" />
          </button>
        </el-tooltip>
      </div>
    </div>
    <div class="form-row">
      <form :class="{ 'loading-opacity': preloader, 'col-sm-10 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin }">
        <div class="form-group">
          <h3 class="text-center mb-0">
            Documents Uploads
          </h3>
        </div>
        <upload-btn :fileObj="documentObj"
                    :renderType="type.UploadDataTable"
                    :emailAddress="emailAddress"
                    :tableId="tableId"
                    :screeningSchedule="screeningSchedule"
                    :auto-upload="false"
        />
        <div class="content-wrapper">
          <app-table :id="tableId"
                    :options="options"
                    @action="getListAction"
          />
          <app-delete-modal v-if="deleteConfirmationModalActive"
                            :preloader="deleteLoader"
                            modal-id="demo-delete"
                            @confirmed="confirmed"
                            @cancelled="cancelled"/>
        </div>
      </form>
    </div>
</div>

</template>

<script>
import {TableHelpers} from "@Views/Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "@/core/helpers/CoreLibrary";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {File} from "@Views/Screening/utility/apiAgent";
import {APPLICANT_FILES} from "@/app/Config/ScreeningAppUrl";
import {uploadBtnRenderType} from "@Views/Screening/utility/enums";
import {axiosPost} from "@/app/Helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  name: "UploadDocuments",
  mixins: [FormMixin, TableHelpers],
  props: {
    preloader: {
      type: Boolean,
      default: false
    },
    emailAddress: {
      type: String,
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    candidateId: {
      type: Number,
    },
    screeningSchedule: {
      type: Object,
    }
  },
  data() {
    return {
      instructionShow: true,
      documentObj: {},
      tableId: "document-table",
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: '',
        showHeader: true,
        columns: [
          {
            title: this.$t("Document"),
            type: "custom-html",
            key: "file_name",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("Type"),
            type: "custom-html",
            key: "type",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          // {
          //   title: this.$t("created_at"),
          //   type: "custom-html",
          //   key: "created_at",
          //   modifier: (value) => {
          //     var date = moment(value).format("DD-MM-YYYY");
          //     return `<span>${this.$t(date)}</span>`;
          //   },
          // },
          {
            title: this.$t("Conversion"),
            type: "custom-html",
            key: "completion_percentage",
            modifier: (value, row) => {
              let status = 'NA'
              if (row.file_extension === 'pdf'){
                 status = !value?'Completed':'Failed';
              }

              return `<span>${this.$t(status)}</span>`;
            },
          },
          {
            title: this.$t("File Name"),
            type: "custom-html",
            key: "file_name",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("View"),
            type: "custom-link",
            key: "file_path"
          }
        ],
        actions: [
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "demo-delete",
          }
        ],
        filters: [],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      type: uploadBtnRenderType
    };
  },

  created() {
    this.options.url = `${APPLICANT_FILES}`;
    this.options.url += this.emailAddress ? `?email=${this.emailAddress}` : `?id=${this.candidateId}`;
    // this.addDocumentControlBtn();
    this.options.columns = [...this.options.columns, this.actionObj];
    this.$hub.$on('table-checkbox-changed', ({ row, key, value }) => {
        this.saveCheckboxStatus(row, value)
    })
    this.$hub.$emit("candidateDetailActiveIndex", 7);


  },
  mounted(){
    if (window.innerWidth < 768) {
      alert('Please select file from gallery.')
    }
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      }
    },
    confirmed() {
      this.deleteLoader = true;
      File.deleteDocument(this.rowData.id)
          .then((response) => {
            this.deleteLoader = false;
            $("#demo-delete").modal("hide");
            this.cancelled();
            this.$toastr.s(response.data.message);
            
            // 🔹 Notify parent about the deleted document
            this.$hub.$emit('document-deleted', this.rowData);
          })
          .catch(({error}) => {
            //trigger after error
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
    openDeleteModal(){
      this.deleteConfirmationModalActive = true;
    },
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    addDocumentControlBtn() {
      if(this.$store.state.user.loggedInUser.id > 0)
      {
        this.options.columns.push(
            {
              title: this.$t("Add To Report"),
              key: "include_in_report",
              type: 'custom-checkbox'
            },
        )
      }

    },
    saveCheckboxStatus(row, value) {
      axiosPost('/applicant-files/change-status', {id: row.id, value: value})
          .then((response) => {
            if (response.data.status == 200) {
              if (response.data.type == 'info') {
                this.$toastr.i(response.data.message);
                this.preloader = false;
              }
              else {
                this.$toastr.s(response.data.message);
                this.preloader = false;
              }
            }
          })
          .catch((error, message) => {
            // Trigger after error
            console.log(error, message)

          })

    },

  },


};
</script>